import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as Actions from './Actions';
import { handleError } from '../../shared/ErrorCatching';
import PlanTemplateModal from './PlanTemplateModal';
import notify from '../../shared/feedback/notifications';
import PlanTemplateList from './PlanTemplateList';
import IPlanTemplate from './IPlanTemplate';

class PlanTemplatesPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            imageReference: '',
            planTemplate: {},
            shouldShowCreateModal: false,
            shouldShowEditModal: false
        };
        this.closeImageModal = this.closeImageModal.bind(this);
        this.deletePlanTemplate = this.deletePlanTemplate.bind(this);
    }

    componentDidMount(): void {
        this.props.actions.list().catch((error: any) => handleError(error));
    }

    openCreateModal = () => {
        this.setState({ shouldShowCreateModal: true });
    };

    closeCreateModal = () => {
        this.setState({ shouldShowCreateModal: false });
    };

    openEditModal = (planTemplate: IPlanTemplate) => {
        this.setState({ shouldShowEditModal: true, planTemplate });
    };

    closeEditModal = () => {
        this.setState({ shouldShowEditModal: false });
    };

    closeImageModal(): void {
        this.setState({ shouldShowImageModal: false });
    }

    deletePlanTemplate(id: number) {
        return this.props.actions
            .deletePlanTemplate(id)
            .then(() => {
                notify.success(Translate('plan-templates/notification/plan-template-deleted'));
            })
            .catch((error: any) => handleError(error));
    }

    render() {
        return (
            <div>
                <h1>{Translate('plan-templates/page/title/plan-templates')}</h1>
                <Button
                    bsSize="large"
                    className="pull-right"
                    onClick={this.openCreateModal}
                    bsStyle="success"
                >
                    {Translate('plan-templates/modal/title/add-plan-template')}
                </Button>
                {this.state.shouldShowCreateModal ? (
                    <PlanTemplateModal
                        editId={-1}
                        shouldShowModal={this.state.shouldShowCreateModal}
                        closeModal={this.closeCreateModal}
                        editInput={{
                            name: '',
                            isAutoGenerationActive: false
                        }}
                    />
                ) : null}
                {this.state.shouldShowEditModal ? (
                    <PlanTemplateModal
                        editId={this.state.planTemplate.id}
                        shouldShowModal={this.state.shouldShowEditModal}
                        closeModal={this.closeEditModal}
                        editInput={this.state.planTemplate}
                    />
                ) : null}
                <PlanTemplateList
                    items={this.props.planTemplates}
                    delete={this.deletePlanTemplate}
                    edit={this.openEditModal}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        planTemplates: state.planTemplates.list
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            list: () => dispatch(Actions.list()),
            deletePlanTemplate: (id: number) => dispatch(Actions.deletePlanTemplate(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanTemplatesPage);
